import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1.647 10.694.258-.369a20.17 20.17 0 0 1 2.138-2.532C6.4 5.435 9.066 4 12 4s5.6 1.435 7.957 3.793a20.17 20.17 0 0 1 2.138 2.532l.258.37c.158.23.287.431.387.594l.128.215.284.496-.284.496c-.105.185-.278.463-.515.81l-.258.369a20.166 20.166 0 0 1-2.138 2.532C17.599 18.565 14.934 20 12 20s-5.6-1.435-7.957-3.793a20.166 20.166 0 0 1-2.138-2.532l-.258-.37a15.075 15.075 0 0 1-.387-.594l-.128-.215L.848 12l.284-.496.128-.215c.1-.163.229-.363.387-.595Zm1.646 1.475.23.33.01.013v.002l.005.007c.557.779 1.2 1.552 1.919 2.272 2.114 2.114 4.29 3.196 6.51 3.207h.079c2.3-.016 4.493-1.203 6.497-3.207a18.009 18.009 0 0 0 1.64-1.892l.002-.003c.094-.126.187-.251.277-.377l.04-.057.029-.041.055-.08.12-.174.115-.169-.114-.17-.158-.225-.081-.117a18.188 18.188 0 0 0-1.925-2.28C16.526 7.19 14.316 6 12 6 9.768 6 7.582 7.082 5.457 9.207c-.72.72-1.362 1.493-1.919 2.272l-.004.007-.002.002-.009.013-.23.33-.114.169.114.17Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionShow24 = createIcon(IconComponent);